import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';
import useAuth from '../../hooks/global/useAuth';
import { Trans, useTranslation } from 'react-i18next';
import useAppMethods from '../../hooks/utility/useAppMethods';
import classnames from 'classnames';
import { useMemo } from 'react';
import CashbackToggle from '../checkout/CashbackToggle';

interface Props {
  subtotal: number;
  total: number;
  hideLoginPrompt?: boolean;
  className?: string;
}

export default function OrderBasketCashback(props: Props) {
  const { subtotal, total, hideLoginPrompt = false, className } = props;

  const { t } = useTranslation(null, { keyPrefix: 'Components:Cashback:OrderBasketCashback' });

  const { isLoggedIn } = useAuth();
  const { toggleLoginModal } = useAppMethods();
  const { hasCashbackProgram, calculateExpectedCashback } = useCashbackProgram();

  const expectedCashback = useMemo(() => calculateExpectedCashback(total), [total, calculateExpectedCashback]);

  const onLoginClick = () =>
    toggleLoginModal({
      openModal: true,
      onCloseRedirect: () => null,
    });

  const renderAvailableBalance = () => {
    if (!isLoggedIn && !hideLoginPrompt) {
      return (
        <button onClick={onLoginClick} className="underline text-gray-700 text-sm font-semibold">
          {t('buttons.log_in')}
        </button>
      );
    }

    return <CashbackToggle subtotal={subtotal} />;
  };

  return (
    hasCashbackProgram && (
      <div className={classnames('w-full', className)}>
        {renderAvailableBalance()}
        {expectedCashback > 0 && (
          <p className="text-sm mt-xs">
            <Trans
              t={t}
              values={{ value: expectedCashback }}
              components={{
                highlight: <span className="text-brand-primary font-semibold" />,
              }}
            >
              sections.expected_cashback
            </Trans>
          </p>
        )}
      </div>
    )
  );
}
